/**
 * i18n constants — supported locales, default namespace, and the
 * app-scoped localStorage key used by the language detector (ADR-014).
 */

export const SUPPORTED_LOCALES = ["de-DE", "en-US"] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: SupportedLocale = "de-DE";
export const FALLBACK_LOCALE: SupportedLocale = "de-DE";

export const DEFAULT_NS = "common" as const;

/** Prefixes the localStorage key with the app name so multiple apps on the
 *  same origin don't overwrite each other's persisted locale. */
export function buildLocalStorageLngKey(appName: string | undefined): string {
  const name = appName && appName.length > 0 ? appName : "app";
  return `${name}:i18nextLng`;
}

export const LOCAL_STORAGE_LNG_KEY = buildLocalStorageLngKey(
  import.meta.env.VITE_APP_NAME,
);
